import { CustomStaticContext } from '@catalogo/core-pre-render/src/types';
import { Config } from '@catalogo/core-configuration';
import { PreRenderQuery } from '@catalogo/core-types';
import { formatRegions } from './helpers';

type SetCDNType = (context: CustomStaticContext, data: PreRenderQuery | undefined, config: Config) => void;

export const setCDNRegion: SetCDNType = (context, data, config) => {
  const maxAge = 24 * 60 * 60 * 1000; // 1 day

  if (context.cookies.some(c => c.key === 'mesoRegion')) {
    return null;
  }

  if (data?.region) {
    const regions = formatRegions({ ...data?.region }, config.cookieDomain, maxAge);
    context.cookies = context.cookies.concat(regions);
  }
};
